export const RESET_EDITING_QUEST = 'RESET_EDITING_QUEST';

export const resetEditingQuest = () => {
  return {
    type: RESET_EDITING_QUEST
  };
};
